import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const NOOP_CLICK_HANDLER = () => void 0;

export type ItemTag = 'new' | 'beta' | 'deprecated' | 'experimental' | 'external';


export interface ItemBase {
  label: string;
  tags?: ItemTag[];
  icons?: {
    end?: IconDefinition;
  };
}

export interface ItemWithHref extends ItemBase {
  href: string;
}

export interface ItemWithRoute extends ItemBase {
  route: string;
  activated?: (active: boolean) => void;
}

export interface ItemWithClickHandler extends ItemBase {
  click: () => void;
}

export type LeafItem = ItemWithHref | ItemWithRoute | ItemWithClickHandler;

export interface BranchItem extends ItemBase {
  type: 'section' | 'sub-section' | 'nested' | 'group';
  children: NavItem[];
}

export type NavItem = LeafItem | BranchItem;